import { useEffect, useState } from 'react';
import axios from 'axios';

// Use environment variable to define the base URL
const BASE_URL = process.env.REACT_APP_BASE_URL;

const useFetch = (endpoint) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            if (!endpoint) return;

            setLoading(true);
            setError(null);

            try {
                const url = `${BASE_URL}${endpoint}`;  // Construct full URL from base URL and endpoint
                const response = await axios.get(url);
                setData(response.data);
            } catch (err) {
                setError(err.message || "Something went wrong");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [endpoint]);  // Refetch if endpoint changes

    return { data, loading, error };
};

export default useFetch;